import repository from './repository';

let CronSubscriberRepository = repository('/cron_subscribers');

CronSubscriberRepository.blankSubscriber = () => {
    return {
        name: '',
        interval: process.env.VUE_APP_CRONSUBSCRIBER_DEFAULT_INTERVAL,
        active: false,
        project_id: '',
        event_name: ''
    }
};

CronSubscriberRepository.validate = {
    name: (name) => {
        return (name.length >= process.env.VUE_APP_VALIDATION_CRONSUBSCRIBER_MIN_NAME_LENGTH && name.length <= 255);
    },
    interval: (interval) => {
        return interval >= 1;
    },
    project: (p) => {
        return p > 0;
    },
    event: (e) => {
        return e.length > 1;
    }
};

export default CronSubscriberRepository;
